import { FieldInsights } from "@/types/fieldInsights";
import { ProcessingStatus } from "@/types/fieldNitrogenPlan";
import { roundTo } from "@/lib/utils/numbers";
import { useI18n } from "@/lib/i18n/useI18n";

export type FormatUnit = ReturnType<typeof useI18n>["formatUnit"];

export function getRateValue({
    trialField,
    recommendation,
    viewAllRates,
    plan,
    formatUnit,
}: {
    trialField: boolean;
    recommendation: FieldInsights["recommendation"];
    viewAllRates: boolean;
    plan: FieldInsights["default_nitrogen_plan_simulation"];
    formatUnit: FormatUnit;
}): string {
    if (trialField) return "Trial Field";

    if (!recommendation.recommend_fertigation && !viewAllRates) {
        return "No recommendation";
    }

    if (!plan) return "";

    if (plan.processing_status !== ProcessingStatus.COMPLETED) {
        return "No rate found";
    }

    return `${roundTo(plan.current_rate, 1)} ${formatUnit("lb_ac", "kg_ha")}`;
}